import { ChangeEvent, useCallback } from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';

interface DateQueryFormProps {
  from?: string;
  onChangeFrom?: (value: string) => void;
  to?: string;
  onChangeTo?: (value: string) => void;
}

const DateQueryForm = (props: DateQueryFormProps) => {
  const { from, onChangeFrom, to, onChangeTo } = props;
  const handleChangeFrom = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onChangeFrom?.(e.target.value);
    },
    [onChangeFrom]
  );
  const handleChangeTo = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onChangeTo?.(e.target.value);
    },
    [onChangeTo]
  );
  return (
    <Grid container width={317} spacing={2}>
      <Grid item xs={2}>
        <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
          <Typography align="left">From</Typography>
        </Box>
      </Grid>
      <Grid item xs={10}>
        <TextField
          size="small"
          type="date"
          fullWidth
          value={from}
          inputProps={{
            max: '9999-12-31',
          }}
          onChange={handleChangeFrom}
        />
      </Grid>
      <Grid item xs={2}>
        <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
          <Typography align="left">To</Typography>
        </Box>
      </Grid>
      <Grid item xs={10}>
        <TextField
          size="small"
          type="date"
          fullWidth
          value={to}
          inputProps={{
            max: '9999-12-31',
          }}
          onChange={handleChangeTo}
        />
      </Grid>
    </Grid>
  );
};

export { DateQueryFormProps };
export default DateQueryForm;
